import { Injectable } from '@angular/core';
import { PlayerTeamService } from '@tcc-mono/classifact/shared/data-access/classifact-api';
import { PlayerTeam } from '@tcc-mono/classifact/shared/data-access/models';
import { CoreRepository } from '@tcc-mono/shared/data-access';

@Injectable({
  providedIn: 'root'
})
export class PlayerTeamRepository extends CoreRepository<PlayerTeam> {
  public constructor(protected _playerTeamService: PlayerTeamService) {
    super({ name: 'avatars' }, _playerTeamService);
  }
}
